export function MiraWordmark({ size, color }: { size?: number; color?: string }) {
  return (
    <span
      style={{
        fontFamily: "Arial, Helvetica, sans-serif",
        fontSize: size,
        fontWeight: 600,
        lineHeight: 1,
        color,
        letterSpacing: "-0.02em",
      }}
    >
      Mirafans
    </span>
  );
}

export function MiraMark({ size = 26 }: { size?: number }) {
  const width = Math.round(size * (280 / 214));

  return (
    <span
      aria-hidden="true"
      className="inline-block shrink-0 bg-contain bg-center bg-no-repeat"
      style={{ width, height: size, backgroundImage: "url('/mira-mark.png')" }}
    />
  );
}

export function MiraLogo({
  size = 26,
  color = "var(--color-accent)",
}: {
  size?: number;
  color?: string;
}) {
  return (
    <span className="inline-flex select-none items-center gap-2.5" style={{ color }}>
      <MiraMark size={size} />
      <MiraWordmark size={size * 0.82} color="var(--color-paper)" />
    </span>
  );
}
